module.exports = __webpack_public_path__ + "assets/img/客户服务.83246fa5.jpg";